/**
 * Форматы, которые принимает загрузка аватара (сервер — белый список
 * изображений, см. StorageService). Кадрирование в квадрат делает
 * PhotoCropModal на клиенте — штатным canvas, без нативной обработки
 * изображений на сервере.
 */
export const AVATAR_ACCEPT = 'image/jpeg,image/png,image/webp';
